import classNames from 'classnames';
import React from 'react';

interface Props {
    inline?: boolean;
    spacing?: 'small' | 'default';
    children: React.ReactNode;
}

function List({ inline, spacing, ...props }: Props) {
    const children = React.Children.toArray(props.children);

    const classes = classNames('list', {
        'list--inline': inline,
        'list--unstyled': true,
        [`list--${spacing}-space`]: spacing !== 'default',
    });

    return (
        <ul className={classes}>
            {children.map((item, i) => (
                <li key={i} className="list__item">
                    {item}
                </li>
            ))}
        </ul>
    );
}

List.defaultProps = {
    spacing: 'default',
    inline: false,
};

export default List;
